import React, { FC, useCallback } from 'react';
import { ResourceAction, openModalByName, requestResourceByName } from 'ia-react-core';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ConfirmResetAuthenticationFactors from '../ConfirmResetAuthenticationFactors';
import Constants from '../../../Constants';
import { AuthenticationFactorsResourceInfo } from '../../AuthenticationFactorsResource/AuthenticationFactorsResource';
import { getIdentityManagementApiRoot } from '../../../utils/getIdentityManagementApiRoot';
import { StyledButton } from '../AuthenticationFactors.styles';

export interface ResetAuthenticationFactorsButtonProps { }

const ResetAuthenticationFactorsButton: FC<ResetAuthenticationFactorsButtonProps> = () => {
  const { t } = useTranslation('AuthenticationFactors');
  const dispatch = useDispatch();

  const onSuccess = useCallback(() => {
    dispatch(requestResourceByName(AuthenticationFactorsResourceInfo.name));
  }, [dispatch]);

  const handleResetAuthenticationFactors = useCallback(() => {
    dispatch(openModalByName('confirmResetAuthenticationFactors'));
  }, [dispatch]);

  return (
    <>
      <ResourceAction
        name="ResetAuthenticationFactorsResource"
        url={`${getIdentityManagementApiRoot(Constants.MfaProfileController)}/factors`}
        method="DELETE"
        onSuccess={onSuccess}
      >
        {({ pending }) => (
          <StyledButton
            data-testid="authentication-factors-button"
            busy={pending}
            outline
            onClick={handleResetAuthenticationFactors}
          >{t('resetButton')}
          </StyledButton>
        )}
      </ResourceAction>
      <ConfirmResetAuthenticationFactors />
    </>
  );
};

export default ResetAuthenticationFactorsButton;
